import Swal from "sweetalert2";

export const onClickFileNewTab = (fileUrl, isVideo = false) => {
  if (!fileUrl) {
    Swal.fire({
      icon: "error",
      title: "파일 열기 오류",
      text: "파일을 열 수 없습니다.",
      customClass: {
        popup: "custom-swal-popup",
      },
    });
    return;
  }

  const width = 500;
  const height = 500;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  const newWindow = window.open("", "_blank", `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=no`);

  if (!newWindow) {
    Swal.fire({
      icon: "error",
      title: "팝업 차단됨",
      text: "브라우저 팝업 설정을 확인해주세요.",
    });
    return;
  }

  // HTML 구성
  const htmlContent = isVideo
    ? `
      <html>
        <head>
          <title>영상 보기</title>
          <script src="https://cdn.jsdelivr.net/npm/hls.js@latest"></script>
          
        </head>
        <body style="margin:0; background-color:black; display:flex; justify-content:center; align-items:center; height:100vh;">
          <video id="video" controls autoplay style="max-width:100%; max-height:100%;"></video>
          <script>
            const video = document.getElementById('video');
            if (Hls.isSupported()) {
              const hls = new Hls();
              hls.loadSource('${fileUrl}');
              hls.attachMedia(video);
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              video.src = '${fileUrl}';
            } else {
              document.body.innerHTML = '<p style="color:white;">지원되지 않는 브라우저입니다.</p>';
            }
          </script>
        </body>
      </html>
    `
    : `
      <html>
        <head><title>이미지 보기</title></head>
        <body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background:#000;">
          <img src="${fileUrl}" alt="미디어 파일" style="max-width:100%; max-height:100%;" />
        </body>
      </html>
    `;

  newWindow.document.open();
  newWindow.document.write(htmlContent);
  newWindow.document.close();
};
